import { Card } from "react-bootstrap";
import React from "react";

export default (props) => {
  let titleClass = " card-title";
  if (props.large) {
    titleClass = "font-large-1 card-title text-center";
  }
  return (
    <div className={props.col}>
      <Card>
        {props.title && (
          <Card.Header className={titleClass}>{props.title}</Card.Header>
        )}
        <Card.Body>{props.children}</Card.Body>
      </Card>
    </div>
  );
};
